import Pristine from 'pristinejs';
import {DASHBOARD_URL} from './config';
import {openVimeoOverlay} from './video';
import {createXHR, PristineConfig, showOverlay} from './utils';
import {startLoading, finishLoading} from './loading';
import Payments from './payments';
import {API_URL} from './config';

export let isAuthenticated = false;

// Setup Facebook Auth
window.fbAsyncInit = function() {
  FB.init({
    appId: 734372160756197,
    cookie: true,
    xfbml: true,
    version: 'v8.0',
  });
  FB.AppEvents.logPageView();
  FB.Event.subscribe('xfbml.render', facebook.finishedRenderingLoginBtn);
  FB.Event.subscribe('auth.statusChange', facebook.statusChanged);

  // FB.getLoginStatus(async response => await facebook.statusChanged(response));
};

const init = () => {
  checkAuthStatus();

  document.querySelectorAll('.js-sign-in-btn').forEach((el) => el.addEventListener('click', openSignInOverlay));
  document.querySelectorAll('.js-sign-up-btn').forEach((el) => el.addEventListener('click', openSignUpOverlay));
  document.querySelectorAll('.js-reset-password-btn').forEach((el) => el.addEventListener('click', openResetPasswordOverlay));
  document.querySelectorAll('.js-free-content-btn').forEach((el) => el.addEventListener('click', openFreeContentOverlay));

  // loading spinner when My Dashboard button clicked
  document.querySelectorAll('.js-dashboard-btn').forEach((el) => el.addEventListener('click', (event) => startLoading(null, event.currentTarget, true)));

  const signInForm = document.getElementById('sign-in-form');
  const signUpForm = document.getElementById('sign-up-form');
  const resetPasswordForm = document.getElementById('reset-password-form');

  setupSignInForm(signInForm);
  setupSignUpForm(signUpForm);
  setupResetPasswordForm(resetPasswordForm);
  initGoogleAuth();
};

const initGoogleAuth = () => {
  const btn = document.querySelectorAll('.login-with-google-btn');

  btn.forEach((el) => {
    el.addEventListener('click', () => {
      // TODO:
      const googleAuthRedirect = window.sessionStorage.getItem('string-redirect-google-auth');
      if (googleAuthRedirect) {
        window.location.href = `${API_URL}/api/v2/user/auth/google?${googleAuthRedirect}`;
      } else {
        window.location.href = `${API_URL}/api/v2/user/auth/google`;
      }
    });
  });
};

const openSignInOverlay = (event, {flow = null} = {}) => {
  let persistFlow = false;
  if (event) {
    event.preventDefault();
    persistFlow = !!event.currentTarget.dataset.persistFlow;
  }

  // check that we are not persisting active flow
  if (!persistFlow && flow) {
    window.sessionStorage.setItem('flow', flow);
  } else if (!persistFlow) {
    window.sessionStorage.removeItem('flow');
  }

  showOverlay('sign-in-overlay');
};

const openSignUpOverlay = (event, {flow = null, data = null} = {}) => {
  let persistFlow = false;
  if (event) {
    event.preventDefault();
    persistFlow = !!event.currentTarget.dataset.persistFlow;
  }

  // check that we are not persisting active flow
  console.log(persistFlow, flow);
  if (!persistFlow && flow) {
    window.sessionStorage.setItem('flow', flow);
    if (data && data.urlParams) {
      window.sessionStorage.setItem('urlParams', data.urlParams);
    }
  } else if (!persistFlow) {
    window.sessionStorage.removeItem('flow');
  }

  // prepare sign up overlay with content for flow
  const signUpHeadingEl = document.getElementById('sign-up-overlay').querySelector('.js-sign-up-heading');
  switch (window.sessionStorage.getItem('flow')) {
    case 'authenticatePurchase':
      signUpHeadingEl.textContent = signUpHeadingEl.dataset.headingPurchase;
      break;
    case 'authenticateSelection':
      signUpHeadingEl.textContent = signUpHeadingEl.dataset.headingPurchase;
      break;
    default:
      signUpHeadingEl.textContent = signUpHeadingEl.dataset.headingDefault;
      break;
  }

  showOverlay('sign-up-overlay');
};

const openResetPasswordOverlay = (event) => {
  if (event) {
    event.preventDefault();
  }
  showOverlay('reset-password-overlay');
};

const openFreeContentOverlay = (event) => {
  if (isAuthenticated) {
    // display free content
    openVimeoOverlay(event);
  } else {
    window.sessionStorage.setItem('freeContentUrl', event.currentTarget.dataset.videoUrl);
    openSignUpOverlay(event, {flow: 'freeContent'});
  }
};

export const checkAuthStatusAsync = () => new Promise((resolve, _) => {
  // Construct an HTTP request
  const xhr = createXHR({
    method: 'GET',
    endpoint: '/api/v2/user/check-auth-status',
  });

  xhr.onload = () => {
    isAuthenticated = xhr.status === 200;
    if (xhr.status === 200) {
      resolve(true);
    } else {
      resolve(false);
    }
  };
});

const checkAuthStatus = () => {
  // Construct an HTTP request
  const xhr = createXHR({
    method: 'GET',
    endpoint: '/api/v2/user/auth-status',
  });
  xhr.onload = () => {
    isAuthenticated = xhr.status === 200;
    if (xhr.status === 200) {
      userIsAuthenticated();
    } else {
      userIsNotAuthenticated();
    }
  };
};

const userIsAuthenticated = () => {
  document.querySelectorAll('.js-sign-in-btn').forEach((el) => el.classList.add('is-hidden'));
  document.querySelectorAll('.js-sign-up-btn').forEach((el) => el.classList.add('is-hidden'));
  document.querySelectorAll('.js-dashboard-btn').forEach((el) => el.classList.remove('is-hidden'));
};

const userIsNotAuthenticated = () => {
  document.querySelectorAll('.js-sign-in-btn').forEach((el) => el.classList.remove('is-hidden'));
  document.querySelectorAll('.js-sign-up-btn').forEach((el) => el.classList.remove('is-hidden'));
  document.querySelectorAll('.js-dashboard-btn').forEach((el) => el.classList.add('is-hidden'));
};

const setupSignInForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const pristine = new Pristine(form, PristineConfig);
    if (pristine.validate()) {
      form.querySelector('button[type="submit"]').disabled = true;
      sendSignInRequest(form, pristine);
    }
  });
};

const setupSignUpForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const pristine = new Pristine(form, PristineConfig);
    if (pristine.validate()) {
      form.querySelector('button[type="submit"]').disabled = true;
      sendSignUpRequest(form, pristine);
    }
  });
};

const setupResetPasswordForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const pristine = new Pristine(form, PristineConfig);
    if (pristine.validate()) {
      form.querySelector('button[type="submit"]').disabled = true;
      sendResetPasswordRequest(form, pristine);
    }
  });
};

const sendSignInRequest = (form, pristine) => {
  // Collect the form data while iterating over the inputs
  const formData = new FormData(form);
  const data = {
    email: formData.get('email'),
    password: formData.get('password'),
  };

  startLoading(form);

  const xhr = createXHR({
    method: 'POST',
    endpoint: '/api/v2/user/sign-in',
    data,
  });

  xhr.onload = () => {
    isAuthenticated = xhr.status === 200;
    switch (xhr.status) {
      case 200:
        authSuccess(form);
        break;
      case 422:
        finishLoading(form);
        parseErrors(form, JSON.parse(xhr.responseText), pristine);
        break;
      default:
        finishLoading(form);
        console.log('unknown status', xhr.status);
        break;
    }
  };
};

const sendSignUpRequest = (form, pristine) => {
  // Collect the form data while iterating over the inputs
  const formData = new FormData(form);
  const data = {
    name: formData.get('name'),
    email: formData.get('email'),
    password: formData.get('password'),
    url: document.location.href,
  };

  startLoading(form);

  const xhr = createXHR({
    method: 'POST',
    endpoint: '/api/v2/user/sign-up',
    data,
  });
  xhr.onload = () => {
    isAuthenticated = xhr.status === 200;
    switch (xhr.status) {
      case 200:
        authSuccess(form);
        break;
      case 422:
        finishLoading(form);
        parseErrors(form, JSON.parse(xhr.responseText), pristine);
        break;
      default:
        finishLoading(form);
        console.log('unknown status', xhr.status);
        break;
    }
  };
};

const sendResetPasswordRequest = (form, pristine) => {
  // Collect the form data while iterating over the inputs
  const formData = new FormData(form);
  const data = {
    email: formData.get('email'),
  };

  startLoading(form);

  // Construct an HTTP request
  const xhr = createXHR({
    method: 'POST',
    endpoint: '/api/v2/user/reset-password',
    data,
  });

  xhr.onload = () => {
    finishLoading(form);
    isAuthenticated = xhr.status === 200;
    switch (xhr.status) {
      case 200:
        resetPasswordSuccess();
        break;
      case 422:
        parseErrors(form, JSON.parse(xhr.responseText), pristine);
        break;
      default:
        console.log('unknown status', xhr.status);
        break;
    }
  };
};

// NOTE: flows
const authSuccess = (form) => {
  userIsAuthenticated();
  switch (window.sessionStorage.getItem('flow')) {
    case 'authenticatePurchase':
      finishLoading(form);
      Payments.openPurchaseOverlay();
      break;
    case 'authenticateSelection':
      finishLoading(form);
      Payments.openSelectionSubscriptionOverlay();
      break;
    case 'freeContent':
      finishLoading(form);
      const url = window.sessionStorage.getItem('freeContentUrl');
      openVimeoOverlay(null, {url});
      break;
    case 'discount':
      window.sessionStorage.removeItem('string-redirect-google-auth');
      finishLoading(form);
      Payments.openSelectionSubscriptionOverlayWithDiscount();
      isAuthenticated = true;
      document.getElementById('sign-up-overlay').remove('is-hidden');
      break;
    case 'returnUrl':
      finishLoading(form);
      const returnUrl = window.sessionStorage.getItem('returnUrl');
      window.location.href = returnUrl;
      break;
    case 'checkout':
      window.sessionStorage.removeItem('string-redirect-google-auth');
      finishLoading(form);
      const urlParams = window.sessionStorage.getItem('urlParams');
      window.location.href = '/checkout/?' + urlParams;
      break;
    case 'returnCheckout':
      window.sessionStorage.removeItem('string-redirect-google-auth');
      finishLoading(form);
      // const urlParams = window.sessionStorage.getItem('urlParams');
      window.location.href = '/checkout?product_id=1&type=checkout';
      break;
    default:
      window.location.href = DASHBOARD_URL;
  }
};

const resetPasswordSuccess = () => {
  document.getElementById('reset-password-overlay')
      .querySelector('.js-reset-password-success').classList.remove('is-hidden');
};

// Parse server errors and display with relevant input field
const parseErrors = (form, data, pristine) => {
  if (data.hasOwnProperty('message')) {
    for (let i = 0; i < form.length; i++) {
      const input = form[i];
      if (data.message.hasOwnProperty(input.name)) {
        // cycle through errors, checking for custom messages
        data.message[input.name].forEach((error) => pristine.addError(input, input.dataset[`${error}Message`] ? input.dataset[`${error}Message`] : error));
      }
    }
  }
  form.querySelector('button[type="submit"]').disabled = false;
};

const facebook = {
  enabled: () => {
    try {
      return FB !== undefined;
    } catch (error) {
      return false;
    }
  },
  finishedRenderingLoginBtn: () => document.querySelectorAll('.js-fb-btn-rendering-spinner').forEach((el) => el.classList.add('is-hidden')),
  isLoggedIn: (cb) => FB.getLoginStatus((response) => cb(response.status === 'connected')),
  loginUser: (authResponse) => {
    // {
    //   accessToken: string,
    //   data_access_expiration_time: number,
    //   expiresIn: number,
    //   graphDomain: "facebook",
    //   signedRequest: string,
    //   userID: string
    // }
    const data = {
      access_token: authResponse.accessToken,
      user_id: authResponse.userID,
    };

    document.querySelectorAll('.js-fb-btn-rendering-spinner').forEach((el) => el.classList.remove('is-hidden'));
    document.querySelectorAll('.fb-login-button').forEach((el) => el.classList.add('is-hidden'));

    // Construct an HTTP request
    const xhr = createXHR({
      method: 'POST',
      endpoint: '/api/v2/user/auth/facebook',
      data,
    });

    //
    xhr.onload = () => {
      const response = JSON.parse(xhr.responseText);
      switch (xhr.status) {
        case 200:
          if (response.logged_in) {
            document.location.href = DASHBOARD_URL;
            return;
          }
        default:
          document.querySelectorAll('.js-fb-btn-rendering-spinner').forEach((el) => el.classList.add('is-hidden'));
      }
    };
  },

  logoutUser: (cb) => {
    if (!facebook.enabled()) {
      cb();
      return;
    }
    try {
      facebook.isLoggedIn((isLoggedIn) => {
        if (isLoggedIn) {
          FB.logout(() => cb());
        } else {
          cb();
        }
      });
    } catch (e) {
      // facebook sdk failed
      cb();
    }
  },
  statusChanged: (response) => {
    //   {
    //     authResponse: {...},
    //     status: "connected"
    //   };

    if (response.status === 'connected') {
      // user logged into Facebook and connected authenticated Facebook with MusicGurus
      // Log user in
      facebook.loginUser(response.authResponse);
    }
  },
};

export default {
  createXHR, init, openSignInOverlay, openSignUpOverlay, checkAuthStatusAsync,
};
